import React from 'react';

const Icon = ({ size = '42', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 42 42" fill="none" {...other}>
            <path
                d="M3.5 6.666h35c1.223 0 2.167.965 2.167 2.096v25.143c0 1.131-.944 2.095-2.167 2.095h-35c-1.223 0-2.167-.964-2.167-2.095V8.762c0-1.131.944-2.096 2.167-2.096Z"
                stroke="#03060B"
                strokeWidth="2.667"
                strokeLinejoin="round"
            />

            <path stroke="black" strokeWidth="2.667" d="M2.667 22h36.666M23 22a4.333 4.333 0 1 0 0-8.667A4.333 4.333 0 0 0 23 22Z" />

            <path
                d="M30.334 22c1.656 0 3-1.492 3-3.333 0-1.841-1.344-3.334-3-3.334-1.657 0-3 1.493-3 3.334 0 1.84 1.343 3.333 3 3.333Z"
                stroke="black"
                strokeWidth="2.667"
            />

            <path d="m20.666 25.333 6-4.666 6 4.666" stroke="black" strokeWidth="2.667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
export default React.memo(Icon);
